/**
 * @file App.jsx
 * @description Application entry point.
 */

import React from 'react';
import AppProviders from './providers/AppProviders';
import Pages from './Pages';
import 'react-toastify/dist/ReactToastify.css';
import './styles/App.css';
import { Toaster } from 'sonner';
const App = ({ instance }) => {
  return (
    <AppProviders instance={instance}>
      <Toaster position="top-right" richColors closeButton />
      <Pages />
    </AppProviders>
  );
};

export default App;
